// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ra-0";